import { styled } from '../theme';

export const Wrapper = styled('div', {
  height: '200px',
  width: '100%',
});
